import React from "react"
import { Tabs, Layout } from "antd"
import Breadcrumb from "../../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { notification } from "antd"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import ServiceReport from "./service-report"
import Finance from "./finance"

notification.config({
  duration: 1,
  rtl: true,
})

const Index = props => {
  const { t, openNotification } = props
  return (
    <div className="page-content">
      <Layout>
        <MetaTags>
          <title>گزارشات | واحد گاز</title>
        </MetaTags>
        <Breadcrumb title="گزارشات" breadcrumbItem="گزارشات مالی" />
        <Tabs
          destroyInactiveTabPane={true}
          tabBarGutter={16}
          items={[
            // {
            //   key: "1",
            //   label: "گزارش مالی واحد گاز",
            //   children: (
            //     <Finance openNotification={openNotification} translate={t} />
            //   ),
            // },
            {
              key: "2",
              label: "درآمد 2درصد خدمات",
              children: (
                <ServiceReport
                  openNotification={openNotification}
                  translate={t}
                />
              ),
            },
          ]}
        />
      </Layout>
    </div>
  )
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Index))
